<template>
  <BModal
    :modal-name="modalName"
    full
  >
    <LeadImportModal
      :title="$t('import.csv.title')"
      :modal-name="modalName"
    />
  </BModal>
</template>

<script>
import LeadImportModal from '@/components/organisms/user/leadList/modal/LeadImportModal.vue';

export default {
  components: {
    LeadImportModal,
  },
  computed: {
    modalName () {
      return 'CsvImportModal';
    },
  },
};
</script>
